import React from "react";
import Copyright from "./Copyright";

const Footer = () => {
	return (
		<div className="footer">
			<div className="copyright border-top">
				<Copyright/>
			</div>
		</div>
	);
};

export default Footer;
